const data = [
  {
    id: 1,
    unit: 1,
    access: true,
  },
  {
    id: 2,
    unit: 2,
    access: true,
  },
  {
    id: 3,
    unit: 3,
    access: true,
  },
  {
    id: 4,
    unit: 4,
    access: true,
  },
  {
    id: 5,
    unit: 5,
    access: true,
  },
  {
    id: 6,
    unit: 6,
    access: true,
  },
  {
    id: 7,
    unit: 7,
    access: true,
  },
  {
    id: 8,
    unit: 8,
    access: true,
  },
  {
    id: 9,
    unit: 9,
    access: true,
  },
  {
    id: 10,
    unit: 10,
    access: true,
  },
  {
    id: 11,
    unit: 11,
    access: true,
  },
  {
    id: 12,
    unit: 12,
    access: true,
  },
  {
    id: 13,
    unit: 13,
    access: true,
  },
  {
    id: 14,
    unit: 14,
    access: true,
  },
  {
    id: 15,
    unit: 15,
    access: true,
  },
  {
    id: 16,
    unit: 16,
    access: true,
  },
];

export default data;
